import LockIcon from '@material-ui/icons/Lock';
import { Button } from '@material-ui/core';
import _ from 'lodash';
import * as React from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import AgreementsForm from '../components/Forms/AgreementsForm';
import { AgreementsActions, fetchLatestAgreements, acceptAgreements } from '../redux/agreements/agreements.actions';
import * as SettingsActions from '../redux/settings/settings.actions';
import * as ModalsActions from '../redux/modals/modals.actions';
import { IState } from '../redux/store';
import { AGREEMENT_TYPES, LANGUAGES } from '../utils/AgreementConstants';
import translations from '../translations/i18next';
import { ModalTypes } from '../components/Modals/ModalTypes';
import logo from '../assets/logos/logoVashoIconDark.png';

type IReduxProps = ConnectedProps<typeof connector>;

export interface ITermsAndConditionsViewProps extends RouteComponentProps<any> {}

export type ComponentProps = ITermsAndConditionsViewProps & IReduxProps;

class TermsAndConditionsView extends React.Component<ComponentProps> {
  private agreementsFormInstance: any = null;
  private isFormValid: boolean = false;

  async componentDidMount() {
    const { dispatch } = this.props;
    dispatch<any>(SettingsActions.setSpinnerVisible(true));
    try {
      await dispatch<any>(fetchLatestAgreements({ type: AGREEMENT_TYPES.TERM }));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      this.props.history.push('/login');
    }
  }

  onAcceptTermsAndConditions = () => {
    if (this.agreementsFormInstance && this.agreementsFormInstance.handleSubmit) {
      this.agreementsFormInstance.handleSubmit();
    }
  }

  onFormReady = (form: any) => {
    this.agreementsFormInstance = form;
  }

  onValidityChange = (isValid: boolean) => {
    this.isFormValid = isValid;
    this.forceUpdate();
  }

  onAcceptTermsAndConditionsConfirm = (values: { [key: string]: boolean }) => {
    const { dispatch } = this.props;
    let formattedAgreements: any[] = [];
    _.each(_.keys(values), (k) => {
      if (values[k]) {
        formattedAgreements = [...formattedAgreements, k];
      }
    });
    dispatch(AgreementsActions.saveAcceptedAgreements(formattedAgreements));
    setTimeout(() => this.saveAgreements(), 500);
  }

  async saveAgreements() {
    const { dispatch, acceptedAgreements, history } = this.props;
    dispatch<any>(SettingsActions.setSpinnerVisible(true));
    try {
      await dispatch<any>(acceptAgreements({ ids: acceptedAgreements }));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch(AgreementsActions.resetAgreements());
      history.push('/');
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      const t = translations.getFixedT(this.props.language || 'en');
      dispatch<any>(ModalsActions.showModal('errorModal', {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          type: 'DEFAULT_ERROR',
          defaultMessage: t('agreements.errorAcceptTermsAndPrivacy'),
        },
      }));
    }
  }

  render() {
    const { agreements, language } = this.props;
    const languageSuffix = language && language === LANGUAGES.ITALIAN ? 'it' : 'en';
    const t = translations.getFixedT(language || 'en');
    
    return (
      <div style={{ overflow: 'scroll', display: 'flex', flexDirection: 'column', backgroundColor: 'white', height: '100vh', padding: 10 }}>
        <img src={logo} alt="logo" style={{ margin: 'auto', marginTop: 60, marginBottom: 15, alignSelf: 'center', height: 60 }} />
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', marginBottom: 20 }}>
          <LockIcon style={{ color: '#3f3f3f' }} />
          <h3 style={{ color: '#3f3f3f', textAlign: 'center', margin: 0, marginLeft: 10, fontWeight: 'bold' }}>
            {t('agreements.termsAndConditions')}
          </h3>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
          {agreements && agreements.data ?
            <div>
              {agreements.data.length ?
                <iframe scrolling="yes" style={{ borderColor: '#1EBE9C' }} src={`${agreements.data[0].link}/${languageSuffix}`} width="800" height="450" />
              : null}
              <AgreementsForm
                {...({
                  agreements: agreements.data,
                  onSubmit: this.onAcceptTermsAndConditionsConfirm,
                  onFormReady: this.onFormReady,
                  onValidityChange: this.onValidityChange,
                } as any)}
              />
            </div>
          : null}
        </div>
        <Button
          variant="contained"
          disabled={!this.isFormValid}
          style={{ backgroundColor: this.isFormValid ? '#1EBE9C' : '#cccccc', color: 'white', marginTop: 20, alignSelf: 'center', padding: '10px 40px', fontWeight: 'bold' }}
          onClick={this.onAcceptTermsAndConditions}
        >
          {t('agreements.acceptAgreements')}
        </Button>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    agreements: state.agreements,
    acceptedAgreements: state.agreements.acceptedAgreements,
  };
}

const connector = connect(mapStateToProps);
export default connector(withRouter(TermsAndConditionsView));
